import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// combineReducers is re-exported from @reduxjs/toolkit via redux
import { combineReducers } from 'redux';
import authReducer from './slices/authSlice';
import studentReducer from './slices/studentSlice';
import testReducer from './slices/testSlice';
import testSessionsReducer from './slices/testSessionsSlice';
import testSessionProgressReducer from './slices/testSessionProgressSlice';
import sessionReducer from './slices/sessionSlice';
import { authMiddleware } from './middleware/authMiddleware';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'students', 'testSessionProgress', 'tests', 'session'] // Add 'session'
};

const rootReducer = combineReducers({
  auth: authReducer,
  students: studentReducer,
  tests: testReducer,
  testSessions: testSessionsReducer,
  testSessionProgress: testSessionProgressReducer,
  session: sessionReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(authMiddleware),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;